import { ShareDocumentMenu } from '@features/invoices/elements/ShareDocumentMenu'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

import { useQuote } from '../../../../../../routes/QuoteView/contexts/quoteContext'

export const ShareQuoteMenu = () => {
  const { quote, quoteId } = useQuote()

  return (
    <ShareDocumentMenu
      contactId={String(quote?.customer?.externalContactId)}
      customer={quote?.customer}
      documentId={quoteId}
      documentLocale={quote?.locale}
      documentNumber={quote?.estimateNumber}
      documentStatus={quote?.status?.status}
      documentType={InvoiceDocumentType.Quote}
    />
  )
}
